import BaseSobrevivenciaRequest from "../BaseSobrevivenciaRequest"; 

export default class EliminarBeneficiarioRequest extends BaseSobrevivenciaRequest {
  constructor( 
    public canal: string = "PortalBE",
    public codUsuario: string = "",
    public numPreSolicitud: number= 0,
    public parentId : number = 0,
    public idReiterativo : number =0
  ) {
    super(canal, codUsuario, numPreSolicitud);
  }
}
